// i18n local espace Détaillant — FR / EN / ES / Créole (GCF) / Arabe
export const COUNTRIES = [
  { code: 'GP', flag: '🇬🇵', name: 'Guadeloupe' },
  { code: 'MQ', flag: '🇲🇶', name: 'Martinique' },
  { code: 'GF', flag: '🇬🇫', name: 'Guyane' },
  { code: 'RE', flag: '🇷🇪', name: 'La Réunion' },
  { code: 'FR', flag: '🇫🇷', name: 'France' },
  { code: 'HT', flag: '🇭🇹', name: 'Haïti' },
  { code: 'DM', flag: '🇩🇲', name: 'Dominique' },
  { code: 'LC', flag: '🇱🇨', name: 'Sainte-Lucie' },
  { code: 'US', flag: '🇺🇸', name: 'États-Unis' },
  { code: 'ES', flag: '🇪🇸', name: 'Espagne' },
  { code: 'DO', flag: '🇩🇴', name: 'Rép. Dominicaine' },
  { code: 'BE', flag: '🇧🇪', name: 'Belgique' },
];

export const DT = {
  ar: {
    space: "مساحة POP'S — متجر التجزئة", tagline: "POP'S: شريك عروض المنتجات التضامنية — بائع مؤقت في قاعة COOP'ACT",
    company: 'الاسم التجاري', locality: 'المدينة', country: 'البلد', phone: 'الهاتف', prefix: 'الرمز الدولي',
    email: 'البريد الإلكتروني', address: 'بيانات المتجر', slots: 'فترات الاستلام',
    save: 'حفظ', subscribe: 'اشترك — 390 €/شهر', subActive: 'الاشتراك نشط',
    subNeeded: 'الاشتراك مطلوب لإيداع العروض (3 عروض مجانية/شهر).',
    newOffer: 'إيداع عرض', product: 'منتج من كتالوج LOLODRIVE', lotType: 'نوع العرض',
    same: 'عرض ×3 — نفس المنتج', composed: 'عرض ×3 — مركّب', qty: 'عدد العروض',
    desc: 'الوصف', composedDetail: 'تركيبة العرض', submit: 'إيداع العرض',
    myOffers: 'عروضي', credits: "نقاط COOP'ACT", offersUsed: 'عروض هذا الشهر',
    costInfo: 'الإيداع: 2,5 % من قيمة العرض بالنقاط. بعد 3 عروض/شهر: ‎+100 نقطة لكل عرض.',
    register: 'إنشاء حساب متجر التجزئة', login: 'تسجيل الدخول', password: 'كلمة المرور',
    pending: 'قيد الانتظار', approved: 'معتمد', rejected: 'مرفوض',
  },
  fr: {
    space: "Espace POP'S — Détaillant", tagline: "POP'S : Partenaire d'Offres de Produits Solidaires — vendeur éphémère en salle COOP'ACT",
    company: 'Raison sociale', locality: 'Localité', country: 'Pays', phone: 'Téléphone', prefix: 'Indicatif',
    email: 'Adresse email', address: 'Coordonnées du magasin', slots: "Créneaux d'enlèvement",
    save: 'Enregistrer', subscribe: "S'abonner — 390 €/mois", subActive: 'Abonnement actif',
    subNeeded: "Abonnement requis pour déposer des offres (3 offres de lots incluses/mois).",
    newOffer: 'Déposer une offre de lots', product: 'Produit du catalogue LOLODRIVE', lotType: 'Type de lot',
    same: 'Lot ×3 — même produit', composed: 'Lot ×3 — composé', qty: 'Quantité de lots',
    desc: 'Descriptif', composedDetail: 'Composition du lot', submit: "Déposer l'offre",
    myOffers: 'Mes offres', credits: 'Crédits COOP\'ACT', offersUsed: 'Offres ce mois-ci',
    costInfo: 'Dépôt : 2,5 % de la valeur du lot en crédits. Au-delà de 3 offres/mois : +100 crédits par lot.',
    register: 'Créer mon compte Détaillant', login: 'Se connecter', password: 'Mot de passe',
    pending: 'En attente', approved: 'Validée', rejected: 'Refusée',
  },
  en: {
    space: "POP'S Space — Retailer", tagline: "POP'S: Solidarity Products Offer Partner — pop-up seller in the COOP'ACT room",
    company: 'Company name', locality: 'Locality', country: 'Country', phone: 'Phone', prefix: 'Prefix',
    email: 'Email address', address: 'Store contact details', slots: 'Pickup slots',
    save: 'Save', subscribe: 'Subscribe — €390/month', subActive: 'Subscription active',
    subNeeded: 'Subscription required to submit offers (3 lot offers included/month).',
    newOffer: 'Submit a lot offer', product: 'LOLODRIVE catalogue product', lotType: 'Lot type',
    same: 'Lot ×3 — same product', composed: 'Lot ×3 — composed', qty: 'Number of lots',
    desc: 'Description', composedDetail: 'Lot composition', submit: 'Submit offer',
    myOffers: 'My offers', credits: "COOP'ACT credits", offersUsed: 'Offers this month',
    costInfo: 'Deposit: 2.5% of the lot value in credits. Beyond 3 offers/month: +100 credits per lot.',
    register: 'Create my Retailer account', login: 'Log in', password: 'Password',
    pending: 'Pending', approved: 'Approved', rejected: 'Rejected',
  },
  es: {
    space: "Espacio POP'S — Minorista", tagline: "POP'S: Socio de Ofertas de Productos Solidarios — vendedor efímero en la sala COOP'ACT",
    company: 'Razón social', locality: 'Localidad', country: 'País', phone: 'Teléfono', prefix: 'Prefijo',
    email: 'Correo electrónico', address: 'Datos de la tienda', slots: 'Franjas de recogida',
    save: 'Guardar', subscribe: 'Suscribirse — 390 €/mes', subActive: 'Suscripción activa',
    subNeeded: 'Suscripción necesaria para presentar ofertas (3 ofertas de lotes incluidas/mes).',
    newOffer: 'Presentar una oferta de lotes', product: 'Producto del catálogo LOLODRIVE', lotType: 'Tipo de lote',
    same: 'Lote ×3 — mismo producto', composed: 'Lote ×3 — compuesto', qty: 'Cantidad de lotes',
    desc: 'Descripción', composedDetail: 'Composición del lote', submit: 'Presentar la oferta',
    myOffers: 'Mis ofertas', credits: "Créditos COOP'ACT", offersUsed: 'Ofertas este mes',
    costInfo: 'Depósito: 2,5% del valor del lote en créditos. Más de 3 ofertas/mes: +100 créditos por lote.',
    register: 'Crear mi cuenta de Minorista', login: 'Iniciar sesión', password: 'Contraseña',
    pending: 'Pendiente', approved: 'Aprobada', rejected: 'Rechazada',
  },
  gcf: {
    space: "Espas POP'S — Détayan", tagline: "POP'S : Patnè Òf Pwodui Solidè — vandè éfémè an sal COOP'ACT",
    company: 'Non konpanni-la', locality: 'Vil-la', country: 'Péyi', phone: 'Téléfòn', prefix: 'Endikatif',
    email: 'Adrès mel', address: 'Kòwdoné magazen-la', slots: 'Lè pou vin chèché',
    save: 'Sové', subscribe: 'Abòné — 390 €/mwa', subActive: 'Abònman aktif',
    subNeeded: 'Fò ou abòné pou dépozé òf (3 òf lo enkli chak mwa).',
    newOffer: 'Dépozé on òf lo', product: 'Pwodui katalòg LOLODRIVE-la', lotType: 'Kalité lo',
    same: 'Lo ×3 — menm pwodui', composed: 'Lo ×3 — konpozé', qty: 'Konbyen lo',
    desc: 'Déskripsyon', composedDetail: 'Sa ki adan lo-la', submit: 'Voyé òf-la',
    myOffers: 'Òf an mwen', credits: "Krédi COOP'ACT", offersUsed: 'Òf mwa-lasa',
    costInfo: 'Dépo : 2,5 % valè a lo-a an krédi. Pasé 3 òf/mwa : +100 krédi pa lo.',
    register: 'Kréyé kont Détayan an mwen', login: 'Konekté', password: 'Modpas',
    pending: 'Ka atann', approved: 'Validé', rejected: 'Refizé',
  },
};
